import { ChangeDetectionStrategy, Component, output} from '@angular/core';
import { FieldTextComponent, AbstractFormArrayComponent, FieldNumberComponent, FieldDateComponent } from '@spike/scaffolds';
import { Button } from "primeng/button";
import { TableModule } from "primeng/table";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-order-positions-form',
  providers:[],
  imports: [CommonModule, ReactiveFormsModule,FormsModule, Button, TableModule, CommonModule, FormsModule, FieldTextComponent, FieldNumberComponent, FieldDateComponent],
  templateUrl: './order-positions-form.html'
})

export class OrderPositionsFormComponent extends AbstractFormArrayComponent{
  addRow = output<void>();  
  deleteRow = output<number>();  
  selectRow= output<number>();  
  }
  

